<template>
  <div v-show="false" />
</template>

<script>
import {
  defineComponent,
  useMeta,
  ref,
} from '@nuxtjs/composition-api';
import { productGetters } from '@vue-storefront/gemini';
import { isEmpty } from 'lodash';

export default defineComponent({
  name: 'StructuredProductData',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const structuredProductData = ref();
    const isProductAvailable = props.product?.status
      && props.product?.configurable_options?.some((option) => option?.values?.length)
      && props.product?.variants?.some((variant) => variant?.option_uids?.length);
    const stockStatus = isProductAvailable
      ? 'https://schema.org/InStock'
      : 'https://schema.org/outOfStock';
    structuredProductData.value = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: props.product?.name,
      image: props.product?.image?.url,
      description: props.product?.description?.html.replace(/<[^>]*>/g, ''),
      ...(props.product?.dress_composition && !isEmpty(props.product?.dress_composition) && {
        material: props.product?.dress_composition,
      }),
      sku: props.product?.merchant_sku,
      offers: {
        '@type': 'Offer',
        price: productGetters.getPrice(props.product).special ?? productGetters.getPrice(props.product).regular,
        availability: `${stockStatus}`,
        priceCurrency: 'EUR',
      },
      brand: {
        '@type': 'Brand',
        name: 'Lazzari',
      },
    };

    useMeta(() => ({
      script: [
        {
          innerHTML: JSON.stringify(structuredProductData.value),
          type: 'application/ld+json',
        },
      ],
      __dangerouslyDisableSanitizers: ['script'],
    }));
  },
  head: {},
});
</script>
